import React, { useEffect, useRef } from 'react';
import Message from './Message';
import './MessageList.css';

const MessageList = ({ messages, isLoading, isConnecting, agentState = 'listening', onClickableTextClick }) => {
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  // Show typing indicator when:
  // - Agent is thinking or speaking
  // - OR when no messages yet (initial state)
  // - OR when explicitly loading
  const shouldShowTyping = (
    agentState === 'thinking' || 
    agentState === 'speaking' || 
    isLoading || 
    messages.length === 0
  );

  return (
    <div className="message-list">
      {messages.map((msg) => (
        <Message 
          key={msg.id} 
          message={msg} 
          isUser={msg.sender === 'user'}
          onClickableTextClick={onClickableTextClick}
        />
      ))}
      {shouldShowTyping && (
        <div className="typing-indicator-wrapper">
          <div className="typing-indicator-header">
            <div className="typing-avatar">
              <img src="/assets/agent-logo.png" alt="Agent" className="agent-avatar-icon" />
            </div>
          </div>
          <div className="typing-indicator">
            <div className="typing-dot"></div>
            <div className="typing-dot"></div>
            <div className="typing-dot"></div>
          </div>
        </div>
      )}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default MessageList;
